import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { OptionData, Options } from "select2";
import { checkAndDestroySelect2, globalMatcher, globalTemplateResult } from "../Tools/GlobalMethods";
import { StyleFilterWidget } from "../FiltersWidgets/StyleFilterWidget";
import { FiltersWidget } from "../FiltersWidget";

export class StyleFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;
    controller: FiltersController;
    source?: string;
    parentGroup: FilterGroup;
    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'style';
        this.name = 'Style';
        this.type = 'style';
        this.source = 'AM';
        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>${this.name}</span>
            <select id="styleFilterSelect"
                style="text-align: left;width: 100%;" title="${this.name}">
            </select>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadStyles().then(() => {
                if (this.parentGroup.isDestroyed) return;
                checkAndDestroySelect2('styleFilterSelect');
                let styles: any[] = (this.source === 'BO' ? FilterGroup.boStyles : FilterGroup.styles)!;
                styles = styles.map((element) => {
                    return {
                        id: element._id || '-1',
                        text: element.name,
                        title: this.name,
                        selected: FilterGroup.filters.style?.includes(element)
                    } as OptionData;
                });
                $('#styleFilterSelect').select2({
                    placeholder: {
                        id: '-1',
                        text: 'Choisissez un type'
                    },
                    data: [
                        {
                            id: '-1',
                            text: 'Choisissez un type',
                        } as OptionData,
                        ...styles,
                    ],
                    matcher: globalMatcher,
                    templateResult: globalTemplateResult,
                    multiple: true,
                    dropdownAutoWidth: true,
                    selectionCssClass: 'select-control',

                } as unknown as Options);
            });
            $('#styleFilterSelect').on('change.select2', () => {
                let selectedValues = $('#styleFilterSelect').val() as string[];
                if (selectedValues.length === 0 || selectedValues[0] === '-1') {
                    FilterGroup.filters.style = null;
                } else {
                    FilterGroup.filters.style = FilterGroup.styles!.filter((element) => selectedValues.includes(element._id)) || null;
                }
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters).then(() => {
                    if (FiltersWidget.currentFiltersGroup === this.parentGroup) {
                        if (this.parentGroup.id === 'style') {
                            let parent = this.parentGroup as StyleFilterWidget;
                            FilterGroup.changeProjectPage(FilterGroup.currentPage).then(() => {
                                parent.updateProjectResultsHtml();
                            });
                        }
                    }
                });
            });

        });
        return html;
    }

    generateStringFilter(): string {
        return("");
    }

    destroy(): void {
        $('#styleFilterSelect').off('change.select2');
        checkAndDestroySelect2('styleFilterSelect');
        this.controller.destroy();
    }
}